
















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import draggable from 'vuedraggable';
import fileTag from '@/components/document/fileTag.vue';
import { hasPermission } from '@/utils/utils';
import { mapGetters } from 'vuex';

interface permissions {
  hasProject: boolean;
  hasFund: boolean;
}

@Component({ 
  components: { draggable, fileTag },
  computed: { ...mapGetters(['userInfo'])}
})
class FileExtraction extends Vue {
  userInfo: any;
  currentKey: String = '0';
  node: object = {
    name: '根目录',
    id: 1
  };
  projectTagList: any[] = [
    { name: '基金维度', id: 1 },
    { name: '项目名称', id: 2 },
    { name: '轮次', id: 3 },
    { name: '文档类型', id: 4 },
    { name: '原件编码', id: 5 }
  ];
  permissions: permissions = {
    hasProject: false,
    hasFund: false
  };

  created() {
    const { permissions:queue } = this.userInfo || {};
    this.permissions.hasProject = hasPermission(queue, '/document/fileExtraction/projectFile');
    this.permissions.hasFund = hasPermission(queue, '/document/fileExtraction/fundFile');
    if (!this.permissions.hasProject) {
      this.currentKey = '3';
    }
  }

  tabChange(key) {
    this.currentKey = key;
  }

  back() {
    if (!this.permissions.hasProject) {
      this.currentKey = '3';
      return;
    }
    this.currentKey = '0';
  }
}
export default FileExtraction;
